<div class="wm-snack">
  <div class="wm-snack__content">
    <span class="wm-snack__msg">{{ data.message }}</span>
    <img class="wm-snack__img" src="assets/images/alerts/{{ data.type }}-alert.svg" alt="{{ data.type }}" />
  </div>

  <mat-icon class="wm-snack__close-img" (click)="close()">close</mat-icon>
</div>
